<template>
  <div class="modal fade" id="import-airbnb-rentals" aria-hidden="false" aria-labelledby="exampleGrid" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-simple modal-center" style="min-width:730px">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container">
            <div class="row header">
              <div class="col-8">
                <h4 class="modal-title text-left">{{ $t("account.users.import_new_rentals") }}</h4>
              </div>
              <div class="col-4">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="closeModal('#import-airbnb-rentals')">
                  <span aria-hidden="true" class="close-btn">&times;</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="form-group form-material m-t-15">
            <ul class="sub-items checkbox-primary airbnb-rentals" v-if="!this.smallLoading && this.newAirbnbRentals.length > 0">
              <li class="checkbox-custom checkbox-primary text-align-left m-b-20">
                <input type="checkbox" id="all-rentals" v-model="allRentalsSelected" @change="(e) => selectAllRentals('all',  e.target.checked)">
                <label for="all-rentals">{{ $t("onboarding.select_all") }}</label>
              </li>
              <li v-for="rental in this.newAirbnbRentals" class="checkbox-custom checkbox-primary text-align-left ml-15">
                <input type="checkbox" v-model="rental.checked" :id="`airbnb-rental-${rental.id}`" @change="(e) => selectAllRentals(rental.id,  e.target.checked)" :disabled="rental.already_imported && rental.already_imported == true">
                <label :for="`airbnb-rental-${rental.id}`">{{ rental.name}}
                  <div v-if="rental.already_imported && rental.already_imported == true" style="display:inline"><br/><small>Ce logement est déjà importé sur un autre compte SuperHote</small></div>
                  </label>
              </li>
            </ul>
            <div v-if="!this.smallLoading && this.newAirbnbRentals.length === 0" style="text-align: center;">
              {{ $t("account.settings.no_property") }}
            </div>
          </div>
        </div>
        <v-loading v-bind:isLoading="this.smallLoading" v-bind:height="50" v-bind:width="50" v-bind:viewbox="'0 0 50 50'"
                   v-bind:cx="25" v-bind:cy="25" v-bind:r="22" v-bind:isHeightAuto="true">
        </v-loading>
        <div class="modal-footer text-center m-t-15">
          <div style="background:#f5e1e5; padding:10px;border-radius:5px;margin:10px 0">
            <p v-html="$t('account.users.import_warning')"></p>
          </div>
          <button type="button" class="btn waves-effect waves-classic btn-cancel"
                @click.prevent="closeModal('#import-airbnb-rentals')"
                  data-dismiss="modal"
                  :disabled="this.smallLoading">{{ $t('button.cancel') }}
          </button>
          <button type="button" class="btn btn-primary waves-effect waves-classic btn-save"
            @click.prevent="importNewAirbnbRentals"
            :disabled="this.smallLoading || this.newAirbnbRentals.length === 0 || !this.selectedRentals.length">
            {{ $t("button.import_airbnb") }}
          </button>
          <button v-if="account.plan_id === 4" type="button" class="btn btn-primary waves-effect waves-classic btn-save"
                  @click.prevent="createNewRental"
                  :disabled="this.smallLoading">
            {{ $t("button.create_rental") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import mixin from '../../../../mixins/mixin';
    import rentalService from '../../../../services/rental';
    import Vue from 'vue';

    export default {
      name: 'ImportNewAirbnbRentals',
      data() {
        return {
          smallLoading: false,
          allRentalsSelected: false,
          selectedRentals: [],
          loading: false,
          airbnbAccount: {},
          newAirbnbRentals: [],
          users: {},
          activeAirbnbAccountForImport: {},
        };
      },
      components: {
        VLoading: require('components/loading/loading.vue'),
      },
      mixins: [mixin],
      methods: {
        goToImportPage() {
          Vue.router.push({
            name: 'account.settings.tab',
            params: {
              tab: 'platforms',
              showAirbnbImport: true,
            },
          });
          
          $("div.modal-backdrop.fade.show").remove();
        },
        async importNewAirbnbRentals() {
          this.smallLoading = true;
          await rentalService.importAirbnbListingsToBeds24(this, this.selectedRentals, this.activeAirbnbAccountForImport, false);
          this.smallLoading = false;
          return;
        },
        selectAllRentals(id = null, value) {
          if (id === 'all') {
            if (value) {
              this.selectedRentals = this.newAirbnbRentals;
            } else {
              this.selectedRentals = [];
            }

            this.newAirbnbRentals.map(rental => rental.checked = this.allRentalsSelected);
          } else {
            if (value) {
              const selectedRental = this.newAirbnbRentals.filter(rental => rental.id === id)[0];
              this.selectedRentals.push(selectedRental);
            } else {
              this.selectedRentals = this.selectedRentals.filter(rental => rental.id !== id);
            }

            const length = this.newAirbnbRentals.length;
            const selectedRentalsLength = this.newAirbnbRentals
                                              .filter(rental => rental.checked === true).length;
            this.allRentalsSelected = selectedRentalsLength === length;
          }
            // this.$forceUpdate();
        },
        async openImportNewRentalsModal(account = 'all') {
          this.openModal('#import-airbnb-rentals');
          this.smallLoading = true;
          this.activeAirbnbAccountForImport = account;
          await rentalService.getNewAirbnbRentals(this, account.id);
          this.smallLoading = false;
        },
        show_sync_in_process_modal(){
          if(this.users.isSyncInProgress) {
            if(!$('.sync-in-process-modal').hasClass('show')) {
              $('.sync-in-process-modal').addClass('show');
              $('body').addClass('modal-open');
              $('body').append('<div class="modal-backdrop fade show"></div>');
              $(".modal-content").css({ "display": "block" });
              $(".navbar").css({ "z-index": "0" });
            }
          }
        },
        createNewRental() {
          Vue.router.push({
            name: 'rentals.create',
          });
          this.closeModal('#import-airbnb-rentals');
        }
      },
      computed: {
        account() {
          return this.$store.state.account;
        }
       }
    };
</script>



// WEBPACK FOOTER //
// ImportNewAirbnbRentals.vue?0a01c2d6